import React, { FC, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useAppSelector } from '../../store';
import { selectTeamsContext } from '../../store/selectors/conversation';
// eslint-disable-next-line max-len
import { setDefaultFolderThunk } from '../../store/actions/defaultFolder/thunks';
import {
    selectDefaultFolderLoaded,
    selectDefaultFolderPath,
} from '../../store/selectors/defaultFolder';
import {
    OperationId,
    startFetch,
    stopFetch,
} from '../../store/actions/app/actionCreators';
import {
    fetchCirclesThunk,
    fetchFolderSharesThunk,
} from '../../store/actions/nextcloud/thunks';

export const withDefaultFolderData = <T extends Record<string, unknown>>(
    Component: FC<T>,
): FC<T> =>
    function WithDefaultFolderData(props) {
        const dispatch = useDispatch();
        const teamsCtx = useAppSelector(selectTeamsContext);

        const isTeamsCtxLoaded = Boolean(teamsCtx);

        const isDefaultFolderLoaded = useAppSelector(selectDefaultFolderLoaded);
        const isDefaultFolderSet = useAppSelector(selectDefaultFolderPath);

        const isChannelOrTeam =
            teamsCtx?.team?.groupId || teamsCtx?.channel?.id;

        useEffect(() => {
            if (!isChannelOrTeam) {
                return;
            }
            dispatch(setDefaultFolderThunk());
            dispatch(fetchCirclesThunk());
        }, [dispatch, isChannelOrTeam]);

        useEffect(() => {
            if (isDefaultFolderSet) {
                dispatch(fetchFolderSharesThunk());
            }
        }, [dispatch, isDefaultFolderSet]);

        if (!isTeamsCtxLoaded) {
            return null;
        }

        if (isChannelOrTeam) {
            if (!isDefaultFolderLoaded) {
                dispatch(
                    startFetch({
                        id: OperationId.LoadUserConfiguration,
                        message: 'load_serverfiles',
                    }),
                );
                return null;
            }

            dispatch(
                stopFetch({
                    operationId: OperationId.LoadUserConfiguration,
                }),
            );
            return React.createElement(Component, props, props?.children);
        }

        return React.createElement(Component, props, props?.children);
    };

export default withDefaultFolderData;
